import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = {
  key: 1,
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
  type: "button",
  disabled: ""
}
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-3 col-sm-12 col-lg-3 col-xl-3 col-xxl-3 col-xm-12" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "col-md-3 col-sm-12 col-lg-3 col-xl-3 col-xxl-3 col-xm-12" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = { class: "col-md-3 col-sm-12 col-lg-3 col-xl-3 col-xxl-3 col-xm-12" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = { class: "col-md-3 col-sm-12 col-lg-3 col-xl-3 col-xxl-3 col-xm-12" }
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_17 = { class: "table-responsive" }
const _hoisted_18 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium text-end pe-0 sm" }
const _hoisted_27 = { class: "dropdown" }
const _hoisted_28 = { class: "dropdown-menu" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.checkPermission('AddPaiement'))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
              to: "/paiement"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode(" Nouveau Paiement ", -1),
                _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.valideEtape3)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getPoint())),
              class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("i", { class: "flaticon-download position-relative ms-5 fs-12" }, null, -1),
              _createTextVNode(" Exporter ", -1)
            ]))]))
          : _createCommentVNode("", true),
        (!_ctx.valideEtape3)
          ? (_openBlock(), _createElementBlock("button", _hoisted_5, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("span", {
                class: "spinner-grow spinner-grow-sm",
                role: "status",
                "aria-hidden": "true"
              }, null, -1),
              _createElementVNode("span", { class: "visually-hidden" }, "Chargement...", -1)
            ]))]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mot clé ", -1)),
              _createVNode(_component_Field, {
                modelValue: _ctx.motCle,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.motCle) = $event)),
                name: "mot",
                type: "text",
                "aria-disabled": "true",
                class: "form-control shadow-none fs-md-15 text-black",
                placeholder: "Recherche par mot clé"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "mot",
                class: "text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Usager ", -1)),
              _createVNode(_component_Field, {
                modelValue: _ctx.usager,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.usager) = $event)),
                name: "contrat"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                  }, field, {
                    placeholder: "Sélectionner un usager",
                    contratholder: "Rechercher une usager",
                    "filter-results": false,
                    onSelect: _ctx.usagerSelect,
                    "min-chars": 3,
                    "resolve-on-load": false,
                    delay: 0,
                    searchable: true,
                    "options-limit": 300,
                    options: async (query) => {
                    return await _ctx.getUsager(query)
                  },
                    noResultText: "Aucun enregistrement trouvé",
                    noOptionsText: "Tapez au moins trois caractères"
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "onSelect", "options"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "contrat",
                class: "text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Secteur ", -1)),
              _createVNode(_component_Field, {
                name: "secteur",
                modelValue: _ctx.secteur,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.secteur) = $event)),
                class: "form-control shadow-none fs-md-15 text-black"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                  }, field, {
                    options: _ctx.secteursOptions,
                    searchable: true,
                    noResultText: "Aucun enregistrement trouvé",
                    placeholder: "Rechercher par secteur"
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "secteur",
                class: "text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Etats ", -1)),
              _createVNode(_component_Field, {
                name: "etat",
                modelValue: _ctx.etat,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.etat) = $event)),
                class: "form-control shadow-none fs-md-15 text-black"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                  }, field, {
                    options: _ctx.etatsOptions,
                    searchable: true,
                    noResultText: "Aucun enregistrement trouvé",
                    placeholder: "Rechercher par secteur"
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "secteur",
                class: "text-danger"
              })
            ])
          ])
        ])
      ]),
      _cache[15] || (_cache[15] = _createElementVNode("hr", null, null, -1)),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("table", _hoisted_18, [
          _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Locataire "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Exploitant "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Place "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Loyer "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Mois Total "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Mois Payé "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Total "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              }, " Actions ")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.retours, (ret, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_19, _toDisplayString(ret.locataire), 1),
                _createElementVNode("td", _hoisted_20, _toDisplayString(ret.exploitant), 1),
                _createElementVNode("td", _hoisted_21, _toDisplayString(ret.ncode_emp), 1),
                _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.separateur(parseFloat(ret.loyer))), 1),
                _createElementVNode("td", _hoisted_23, _toDisplayString(ret.moisDuTotal), 1),
                _createElementVNode("td", _hoisted_24, _toDisplayString(ret.moisPaye), 1),
                _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.separateur(parseFloat(ret.montantPaye))), 1),
                _createElementVNode("td", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _cache[13] || (_cache[13] = _createElementVNode("span", {
                      class: "badge text-white bg-secondary fs-15 dropdown-toggle",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, [
                      _createTextVNode(" Actions "),
                      _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                    ], -1)),
                    _createElementVNode("ul", _hoisted_28, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          onClick: ($event: any) => (_ctx.getApercu(ret)),
                          type: "button",
                          class: "dropdown-item d-flex align-items-center"
                        }, [...(_cache[12] || (_cache[12] = [
                          _createElementVNode("i", { class: "flaticon-send lh-1 me-8 position-relative top-1" }, null, -1),
                          _createTextVNode(" Apercu du statut ", -1)
                        ]))], 8, _hoisted_29)
                      ])
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}